// Globals
import { useEffect } from 'react';

// Store
import { useAppDispatch } from '@/store';

// Api
import { AuthAPI } from '@/api';

// Modules
import { setIsAuthorized } from '@/modules/Auth';

// Utils/Helpers
import { clearSession, getAuthToken, getRefreshToken, isTokenExpired, setAuthToken } from '@/utils';

/**
 * Определяет состояние сессии на старте приложения.
 * Пока состояние неизвестно, isAuthorized остаётся null и ProtectedRoute держит лоадер,
 * поэтому неавторизованный пользователь не видит интерфейс.
 */
const useSessionRefresh = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    let isActual = true;

    const restoreSession = async () => {
      const authToken = getAuthToken();

      if (!isTokenExpired(authToken)) {
        dispatch(setIsAuthorized(true));
        return;
      }

      const refreshToken = getRefreshToken();

      if (!refreshToken) {
        clearSession();
        dispatch(setIsAuthorized(false));
        return;
      }

      try {
        const { data: session } = await AuthAPI.refreshToken({ refreshToken });

        if (!session?.idToken) {
          throw new Error('Session refresh failed');
        }

        setAuthToken(session.idToken);

        if (isActual) {
          dispatch(setIsAuthorized(true));
        }
      } catch {
        clearSession();

        if (isActual) {
          dispatch(setIsAuthorized(false));
        }
      }
    };

    restoreSession();

    return () => {
      isActual = false;
    };
  }, []);
};

export default useSessionRefresh;
